// extracted by mini-css-extract-plugin
module.exports = {"switch":"switch-input_switch__3P84p","text":"switch-input_text__FxMOM","textChecked":"switch-input_textChecked__HuBsv","textDisabled":"switch-input_textDisabled__1IJvV"};